<!-- ============================================================== -->
<!-- Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
<div *ngIf="pageTitle" class="page-titles hide-print" [ngClass]="{'back-bar': showPageBack || showMainPageBack}">
    <div class="d-flex w-100" >
        <div *ngIf="showPageBack" class="m-l-16 cursor-pointer" (click)="onBack()" style="z-index: 0;">
            <i class="mdi mdi-arrow-left mdi-24px"></i>
        </div>
        <div *ngIf="showMainPageBack" class="m-l-16 cursor-pointer" (click)="onMainBack()" style="z-index: 1;">
            <i class="mdi mdi-arrow-left mdi-24px"></i>
        </div>
        <div class="text-center w-100 m-l-10 font-h6 m-b-24" [ngClass]="{'text-white': showPageBack || showMainPageBack}" [ngStyle]="{'margin-left': showPageBack || showMainPageBack ? '-42px':'0'}">
            {{pageTitle}}
        </div>
    </div>

    <!-- <div class="d-flex flex-row">
        <div *ngIf="showPageBack" class="m-l-20 cursor-pointer" style="width: 10px;" (click)="onBack()">
            <i class="mdi mdi-arrow-left mdi-24px"></i>
        </div>
        <div class="text-center w-100 font-h6 m-b-24" [ngStyle]="{'margin-left': showPageBack ? '-20px' : '0'}">
            {{pageTitle}}
        </div>
    </div> -->
    <!-- <hr *ngIf="!showPageBack" class="mobile" style=" border: 1px solid #E1E1E1; margin: 20px 40px 5px 40px;"> -->
</div>

<!-- ============================================================== -->
<!-- End Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
